module.exports = __webpack_public_path__ + "media/images/front/brands/signature/card-fff48ecfc27574dffa679999c18d0ae8.jpg";